import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  fetchEvent(eventId) {
    let url = buildUrl("event/" + eventId)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchAllEvents() {
    let url = buildUrl("event")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchEventsForSlider() {
    let url = buildUrl("event/for/slider")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchEventsForSelect() {
    let url = buildUrl("event/for/select")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchEventsCount() {
    let url = buildUrl("event/count")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  createEvent(formData) {
    let url = buildUrl("event")
    return axios.post(url, formData, buildOptions()).then((res) => res.data)
  },
  updateEvent(formData) {
    let url = buildUrl("event")
    return axios.put(url, formData, buildOptions()).then((res) => res.data)
  },
  deleteEvent(eventId) {
    let url = buildUrl("event/" + eventId)
    return axios.delete(url, buildOptions()).then((res) => res.data)
  },
}
